import {
  GroupTypesSportAndDisciplinesDocument,
  TypeSportRanksAndTitlesCreateMutationHookResult,
  TypeSportRanksAndTitlesRemoveMutationHookResult,
  useTypeSportRanksAndTitlesCreateMutation,
  useTypeSportRanksAndTitlesQuery,
  useTypeSportRanksAndTitlesRemoveMutation,
} from '../../../api';
import { useForm } from 'react-hook-form';
import React, { FC } from 'react';
import { Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { RanksAndTitle } from '../../../module';
import getMessage from '../../../messages';
import { useSnackbar } from 'notistack';

const RanksAndTitles: FC<{ readonly?: boolean; id: string }> = ({ readonly, id }) => {
  const { data } = useTypeSportRanksAndTitlesQuery({ variables: { id } });
  const { handleSubmit, control, errors, reset } = useForm({
    defaultValues: { item: null },
  });
  const { enqueueSnackbar } = useSnackbar();
  const [create]: TypeSportRanksAndTitlesCreateMutationHookResult = useTypeSportRanksAndTitlesCreateMutation({
    update: (proxy, { data }) => {
      proxy.writeQuery({
        query: GroupTypesSportAndDisciplinesDocument,
        data: {
          ...data?.updateDirSport,
        },
      });
    },
  });

  const [remove]: TypeSportRanksAndTitlesRemoveMutationHookResult = useTypeSportRanksAndTitlesRemoveMutation({
    update: (proxy, { data }) => {
      proxy.writeQuery({
        query: GroupTypesSportAndDisciplinesDocument,
        data: {
          ...data?.updateDirSport,
        },
      });
    },
  });

  const onRemove = async (value: string, label: string) => {
    try {
      await remove({
        variables: {
          id,
          idItem: value,
        },
      });
      enqueueSnackbar(`Запись "${label}" успешно удалена`, { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(getMessage(e.message), { variant: 'error' });
    }
  };

  const onSubmit = handleSubmit(async (values?: { item?: { label: string; value: any } | null }) => {
    if (!values?.item) return;
    try {
      await create({
        variables: {
          id,
          idItem: values?.item?.value,
        },
      });
      reset({ item: null });
      enqueueSnackbar(`Запись "${values?.item?.label}" успешно добавлена`, { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(getMessage(e.message), { variant: 'error' });
    }
  });

  if (readonly) {
  }
  return (
    <Grid container>
      <Grid item md={6}>
        <List>
          <form onSubmit={onSubmit}>
            <ListItem key="add_new">
              <RanksAndTitle
                label="Разряд и звание"
                error={!!errors['item']}
                name="item"
                control={control}
                rules={{ required: true }}
              />
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="add" type="submit">
                  <AddIcon color="primary" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </form>
          {data?.dirSport?.clsRanksAndAwards?.map((item) => (
            <ListItem key={item.value}>
              <ListItemText primary={item.label} />
              {!readonly && (
                <ListItemSecondaryAction>
                  <IconButton edge="end" aria-label="delete" onClick={() => onRemove(item.value, item.label)}>
                    <DeleteIcon color="error" />
                  </IconButton>
                </ListItemSecondaryAction>
              )}
            </ListItem>
          ))}
        </List>
      </Grid>
    </Grid>
  );
};

export default RanksAndTitles;
